import {environment} from '../../../environments/environment'

export const BASE_URL = environment.API_BASE
